import BaseModel from '../base/BaseModel.model';
import { ParesEvaluadoresTypes } from '@/enums/ParesEvaluadoresTypes';
import Pregunta from './pregunta.model';
import { EvaluationState } from '@/enums/EvaluationState';

export default class TipoEvaluacion extends BaseModel {

    public evaluacionId: number | null;
    public type: ParesEvaluadoresTypes | null;
    public titulo: string | null;
    public description: string | null;
    public expectResult: boolean;
    public approvalLabel: string | null;
    public disapprovalLabel: string | null;
    public preguntas: Array<Pregunta> = [];
    
    // User Interface variables
    public checkedUI: boolean;
    public disabledUI: boolean;
    public minimumNumberOfEvaluatorsUI: number;
    public requiredEvaluationTypesUI: Array<number> = [];
    public fueCompletada: boolean = false;
    public evaluationState: EvaluationState;
    public mainEvaluationIdUI: number = null;

    constructor() {
        super();
        this.init();
    }

    init() {
        this.checkedUI = false;
        this.disabledUI = false;
        this.evaluacionId = null;
        this.titulo = null;
        this.type = null;
        this.description = null;
        this.expectResult = true;
        this.approvalLabel = "Aprobado";
        this.disapprovalLabel = "No aprobado";
    }
}